import { spiritIslandChapters } from './content';
export const spiritIslandQuickReference = spiritIslandChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('QUICK REFERENCE'));
